import { ButtonNew, ButtonNewVariant } from 'root/src/client/v2/common/components/form/ButtonNew';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { platformIconMap } from 'root/src/shared/constants/dropKeys';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { useRedeemConfirmationModal } from 'root/src/client/web/giveaway/features/RedeemModalConfirmation/hooks/useRedeemConfirmationModal';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
export default function RedeemConfirmationModal(props) {
    const modal = useModal();
    const { onRedeem, isLoading } = useRedeemConfirmationModal(props);
    return (<ModalLayout>
			<div className="flex flex-col justify-center items-center gap-6 pb-4">
				<div className="flex flex-col items-center gap-2">
					<ConfirmationTitle />
					<InformationText />
					<RewardDetails reward={props.reward}/>
				</div>
				<div className="flex justify-center items-center gap-4">
					<ButtonNew disabled={isLoading} onClick={() => modal.hide()} variant={ButtonNewVariant.Error} className="font-bold uppercase h-12" type="button">
						Back
					</ButtonNew>
					<ButtonNew disabled={isLoading} onClick={onRedeem} className="font-bold uppercase h-12 w-32" type="button">
						{isLoading ? <LoadingCircles width={20} height={20}/> : 'Redeem'}
					</ButtonNew>
				</div>
			</div>
		</ModalLayout>);
}
function RewardDetails(props) {
    const { reward } = props;
    const region = 'region' in reward ? reward.region : undefined;
    return (<>
			<div className="flex flex-col justify-center items-center gap-1">
				<div className="flex items-center justify-center gap-1">
					<span className="font-bold">{reward.name}</span>
					{typeof reward.platform === 'string' && <FontAwesomeIcon icon={platformIconMap[reward.platform]}/>}
				</div>
				{typeof reward.region === 'string' && (<span className="capitalize text-sm">
						({region})
					</span>)}
			</div>
			<img className="rounded border-2 border-teal w-[170px] h-[240px] rounded-xl" src={reward.image} alt={reward.name}/>
		</>);
}
function ConfirmationTitle() {
    return (<h1 className="text-2xl font-mono font-bold p-2 text-center">Redeem confirmation</h1>);
}
function InformationText() {
    return (<p className="text-center text-sm">Are you sure you want <br /> to redeem the following
			reward?
		</p>);
}
